import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import './Dashboard.css';

export default function CategorySection() {
  const { role } = useAuth();
  const canEdit = role === 'superadmin';

  const [categories, setCategories] = useState([
    'Food',
    'Tours',
    'Yacht Services',
  ]);
  const [newCategory, setNewCategory] = useState('');

  const handleAdd = () => {
    // Hard block non-superadmins
    if (!canEdit) return;

    if (newCategory.trim() !== '') {
      setCategories([...categories, newCategory.trim()]);
      setNewCategory('');
    }
  };

  return (
    <div className="section-container">
      <div className="section-header">
        <h2>Categories</h2>
        {!canEdit && (
          <p className="section-note">
            Only superadmins can add or edit categories. You can still view the list below.
          </p>
        )}
      </div>

      <div className="section-body">
        <div className="section-controls">
          <input
            type="text"
            placeholder="New category name"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            disabled={!canEdit}
          />
          <button onClick={handleAdd} disabled={!canEdit}>
            Add
          </button>
        </div>

        <ul className="category-list">
          {categories.map((cat, i) => (
            <li key={i}>{cat}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
